/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class OrganizationSettingsModel {
        id: string;
        type: string;
        name: string;
        category: string;
        value: string | boolean;
    }

    export class CompanyFeatureViewModel {
        feature: string;
        organizationalUnitIds: string[];
    }

    export class CompanyFeatureList {
        constructor(public features: CompanyFeatureViewModel[], public isAngel: boolean) { }

        public includeIndoorData(associationId?: string[]) { return this.hasFeature('IncludeIndoorData', associationId) };
        public includeOutdoorData(associationId?: string[]) { return this.hasFeature('IncludeOutdoorData', associationId) };
        public includeSimData(associationId?: string[]) { return this.hasFeature('IncludeSimData', associationId) };
        public includeSurfaceMaterial(associationId?: string[]) { return this.hasFeature('IncludeSurfaceMaterial', associationId) };
        public includeFeedbackModule(associationId?: string[]) { return this.hasFeature('IncludeFeedbackModule', associationId) };
        public includeRvtExport(associationId?: string[]) { return this.hasFeature('IncludeRvtExport', associationId) };
        public includeIfcExport(associationId?: string[]) { return this.hasFeature('IncludeIfcExport', associationId) };
        public includeOutdoorKeynote(associationId?: string[]) { return this.hasFeature('IncludeOutdoorKeynote', associationId) };
        public includeOutdoorFunction(associationId?: string[]) { return this.hasFeature('IncludeOutdoorFunction', associationId) };
        public includeOutdoorOrientation(associationId?: string[]) { return this.hasFeature('IncludeOutdoorOrientation', associationId) };
        public includeOutdoorLevel(associationId?: string[]) { return this.hasFeature('IncludeOutdoorLevel', associationId) };
        public includeSimLevel(associationId?: string[]) { return this.hasFeature('IncludeSimLevel', associationId) };
        public includeUniversalStorage(associationId?: string[]) { return this.hasFeature('IncludeUniversalStorage', associationId) };
        public includeScannedImages(associationId?: string[]) { return this.hasFeature('IncludeScannedImagesArchive', associationId) };
        public allowIndoorCsvDownload(associationId?: string[]) { return this.hasFeature('AllowIndoorCsvDownload', associationId) };
        public allowOutdoorCsvDownload(associationId?: string[]) { return this.hasFeature('AllowOutdoorCsvDownload', associationId) };
        public allowLandscapeCsvDownload(associationId?: string[]) { return this.hasFeature('AllowLandscapeCsvDownload', associationId) };
        public displayBuildingsOnMap(associationId?: string[]) { return this.hasFeature('DisplayBuildingsOnMap', associationId) };

        public hasFeature(feature: string, associationIds: string[]) {
            if (this.isAngel) {
                return true;
            }
            for (var f of this.features) {
                if (f.feature == feature) {
                    if (associationIds == null) {
                        return true;
                    }
                    for (var o of associationIds) {
                        var associationNumber = Number(o);
                        if (f.organizationalUnitIds.some(ou => ou == o) || (f.organizationalUnitIds.some(ou => Number(ou) == associationNumber))) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }
    }

    export class CompanyUIStylingList {
        constructor(public uiStyling: string[]) { }

        public filterChipsHidePrefix() { return this.hasUIStyling('filterChipsHidePrefix') };
        public mapPinShowAssociationName() { return this.hasUIStyling('mapPinShowAssociationName') };
        public universalStorageHideStandardLocality() { return this.hasUIStyling('universalStorageHideStandardLocality') };
        public universalStorageShowDetailedLocality() { return this.hasUIStyling('universalStorageShowDetailedLocality') };
        public modelListHideStandardLocality() { return this.hasUIStyling('modelListHideStandardLocality') };
        public modelListShowDetailedLocality() { return this.hasUIStyling('modelListShowDetailedLocality') };
        public textServiceOverruleModelFilter_Association() { return this.hasUIStyling('textServiceOverruleModelFilter_Association') };
        public textServiceOverruleModelFilter_Department() { return this.hasUIStyling('textServiceOverruleModelFilter_Department') };
        public textServiceOverruleModelFilter_Localizer() { return this.hasUIStyling('textServiceOverruleModelFilter_Localizer') };

        public hasUIStyling(uiStyling: string) {
            for (var s of this.uiStyling) {
                if (s == uiStyling) {
                    return true;
                }
            }
            return false;
       }
    }
}